<template>
    <main class="main">
        <div class="container">
            <h1 class="page-title h1 mt-4">Zarządzanie zgodami</h1>

            <p class="page-lead mb-3">
                Zarządzaj wyrażonymi zgodami na poszczególne obszary.
            </p>
            <div class="a-infoBar a-infoBar--warning mb-3">
                Uwaga! Aby zachować zmiany należy wcisnąć przycisk "Zapisz"
            </div>
            <consent-list
                v-if="marketingConsents"
                :title="consentDetails('EP').title"
                consent-code="EP"
                :consent-details="consentDetails('EP').consentDetails"
                :data="marketingConsents"
                class="mb-3"
            />
            <consent-list
                v-if="marketingConsentsECSP"
                :title="consentDetails('ECSP').title"
                consent-code="ECSP"
                :consent-details="consentDetails('ECSP').consentDetails"
                :data="marketingConsentsECSP"
                class="mb-3"
            />
            <service-login-consents />
        </div>
    </main>
</template>

<script>
import ConsentList from '@/components/settings/ConsentList'
import ServiceLoginConsents from '@/components/consents/ServiceLoginConsents'

export default {
    components: {
        ConsentList,
        ServiceLoginConsents
    },
    computed: {
        marketingConsents() {
            return (
                !this.$store.getters.isShopUser &&
                this.$store.getters.getMarketingConsents
            )
        },
        marketingConsentsECSP() {
            return (
                !this.$store.getters.isShopUser &&
                this.$store.getters.getMarketingECSPConsents
            )
        }
    },
    methods: {
        consentDetails(consentCode) {
            return this.$store.getters.getMarketingDetails(consentCode)
        }
    },
    beforeMount() {
        this.$store.dispatch('consentsFetch')
    }
}
</script>
